<mat-drawer-container autosize hasBackdrop="true" [class]="(isDark) ? 'dark-theme' : 'light-theme'">
  <mat-drawer #drawer mode="over">
    <div class="p2">
      <p>Auto-resizing sidenav {{ isDark }}</p>
    </div>
  </mat-drawer>

  <div class="container-scrollable">
    @if (openFile$ | async; as openFile) {
      <mat-toolbar color="primary" class="app-bar">
        @if (openFile?.projectId) {
          <nav class="flex items-center col-12" aria-label="main navigation">
            <a
              mat-icon-button
              [routerLink]="['/', 'start', openFile?.projectId]"
              aria-label="Open project"
              matTooltip="Open project"
            >
              <mat-icon>home</mat-icon>
            </a>
            <div class="app-bar__title ml1">
              <span class="app-bar__document">{{ openFile?.id }}</span>
              <span class="app-bar__project xs-hide sm-hide">{{ openFile?.shortProjectId }}</span>
            </div>
            <span class="flex-auto"></span>
            <button
              mat-button
              type="button"
              class="app-bar__save"
              [class.app-bar__save--dirty]="openFile.isDirty"
              [disabled]="!openFile.isDirty"
              (click)="save(false)"
              [matTooltip]="openFile.isDirty ? 'Save your changes' : 'All changes are saved'"
            >
              @if (!openFile.isDirty) {
                <mat-icon aria-hidden="true">cloud_done</mat-icon>
              }
              @if (openFile.isDirty) {
                <span class="app-bar__dot" aria-hidden="true"></span>
                Save changes
              } @else {
                <ng-container>
                  Saved
                  @if (openFile.lastModified) {
                    <span class="xs-hide sm-hide">&nbsp;· {{ openFile.lastModified | date: 'shortTime' }}</span>
                  }
                </ng-container>
              }
            </button>
            @if (!instanceData.sciflowAppDomain) {
              <button
                mat-button
                type="button"
                class="app-bar__secondary ml1"
                [class.app-bar__action]="!openFile.isDirty"
                (click)="save()"
                matTooltip="Save and open the export options"
              >
                Export
              </button>
            } @else {
              <button
                [disabled]="openFile.isDirty"
                mat-button
                type="button"
                class="app-bar__secondary ml1"
                [class.app-bar__action]="!openFile.isDirty"
                (click)="openInSciFlow()"
                [matTooltip]="openFile.isDirty ? 'Save your changes first' : 'Import this document to SciFlow'"
              >
                Import to SciFlow
              </button>
            }
          </nav>
        }
      </mat-toolbar>
}

<div class="container-scrollable-wrapper">
  <main id="mainContent" tabindex="-1" class="container-scrollable-overflow relative">
    <router-outlet></router-outlet>
  </main> <!-- container-scrollable-overflow -->
</div> <!-- container-scrollable-wrapper-->


</div> <!-- container-scrollable -->
</mat-drawer-container>
<input type="text" value="" style="display: none;" #copyToClipboardInput />